import React from 'react';
import { Tooltip } from 'react-tooltip';

import useTranslation from '@hooks/useTranslation';

import type { ITableSorting } from '@model/tableSorting';

interface IProps {
  id: string;
  sorting: ITableSorting;
}

const TooltipSort: React.FC<IProps> = ({ id, sorting }) => {
  const { t } = useTranslation();

  const getSortTooltipText = (columnKey: string) => {
    if (!sorting.id) {
      return t('Unsorted');
    }

    const { id, desc } = sorting;
    if (columnKey !== id) {
      return t('Unsorted');
    }

    return sorting.fieldName
      ? `${t('Sorted by')} ${sorting.fieldName} (${desc ? t('descending') : t('ascending')})`
      : `${t('Sorted by')}  ${desc ? t('descending') : t('ascending')}`;
  };
  return (
    <Tooltip
      id={id}
      render={({ content: columnKey }) => {
        if (!columnKey) {
          return null;
        }
        return getSortTooltipText(columnKey);
      }}
    />
  );
};

export default TooltipSort;
